import React, { useEffect, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

export default function Banner() {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    axios
      .get("https://cauverytours.in/cauverytours-backend/admin/banners.php")
      .then((res) => setBanners(res.data))
      .catch((err) => console.error("Error fetching banners:", err));
  }, []);

  return (
    <div className="banner-two-swiper-start">
      <Swiper
  modules={[Pagination, Autoplay]}
  pagination={{ clickable: true }}
  autoplay={{
    delay: 3000,
    disableOnInteraction: false,
  }}
  speed={800}
  loop
>
  {banners.map((banner) => (
    <SwiperSlide key={banner.id}>
      <div
        className="banner-two-main-wrapper-solaric"
        style={{
          backgroundImage: `url(${banner.image_url})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "500px",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="banner-solari-2-content ptb--200 ptb_sm--130">
                <span className="pre animate-text">{banner.welcome_text}</span>
                <h1 className="banner-title animate-text">{banner.title}</h1>
                <p className="disc animate-text">{banner.description}</p>
                <div className="button-solari-banner-area animate-btn">
                  <a href="/about" className="rts-btn btn-primary">
                    Learn More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SwiperSlide>
  ))}
</Swiper>

    </div>
  );
}
